import { render, staticRenderFns } from "./View_Content.vue?vue&type=template&id=0d62f95e&scoped=true"
import script from "./View_Content.vue?vue&type=script&lang=js"
export * from "./View_Content.vue?vue&type=script&lang=js"
import style0 from "./View_Content.vue?vue&type=style&index=0&id=0d62f95e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d62f95e",
  null
  
)

export default component.exports